import $ from 'jquery';

const $window = $(window);
const $postFeaturedImage = $('.post-content-web-page');

function checkVisible() {
  let viewportBottom = $window.scrollTop() + $window.height();
  for (var i = 0; i < $postFeaturedImage.length; i++) {
    let $item = $postFeaturedImage.eq(i);
    var compareBottom = $item.offset().top + $item.height() + 60;
    $item.toggleClass('active', viewportBottom >= compareBottom);
  }
}

setInterval(function () {
  checkVisible();
}, 1);
